/**
 * Ayna tazeliği — iki panelin de kullandığı ortak sözlük.
 *
 * 🔴 Burada durmasının sebebi: aynı ölçünün AdminPanel'de ve müşteri panelinde iki
 * ayrı tanımı olsaydı biri düzeltilip öbürü bayatlardı ve "4 gün 13 sa" ile
 * "4.68 days" aynı veriyi iki farklı dille anlatırdı. Sınıflandırmanın kendisi
 * SUNUCUDA yapılır (`CdcFreshness.Classify`); burası yalnız BİÇİMLENDİRME.
 */

/** Sunucunun döndürdüğü durum adları (RaporGor.Api CdcFreshnessDurumu ile birebir). */
export type AynaDurumu = 'hic' | 'taze' | 'gecikmis' | 'bayat';

/**
 * Saniyeyi Türkçe ve kaba bir ölçekle yaz: 59 sn · 4 dk · 3 sa · 4 gün 13 sa.
 *
 * Kaba olması KASITLI: kullanıcının sorusu "verim ne kadar eski" — saniyesi değil
 * büyüklük mertebesi önemli. Gün ölçeğinde saat de yazılır çünkü "4 gün" ile
 * "4 gün 13 sa" arasındaki fark bir iş gününe denk gelir.
 */
export function yasBicimle(saniye: number | null): string {
  if (saniye === null) return '—';
  if (saniye < 60) return `${Math.max(0, Math.floor(saniye))} sn`;
  const dk = Math.floor(saniye / 60);
  if (dk < 60) return `${dk} dk`;
  const sa = Math.floor(dk / 60);
  if (sa < 24) return `${sa} sa`;
  const gun = Math.floor(sa / 24);
  const kalanSa = sa % 24;
  return kalanSa === 0 ? `${gun} gün` : `${gun} gün ${kalanSa} sa`;
}
